var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0 py-0",attrs:{"fluid":""}},[_c('app-drawer'),_c('div',{class:`${_vm.$vuetify.breakpoint.lgAndUp ? 'content' : ''}`},[_c('router-view',{staticClass:"px-5"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }